import type { Product, Store } from './types';

/**
 * DE: Niedrigster realistischer Regalpreis in Cent.
 * EN: Lowest realistic shelf price in cents.
 */
const MIN_SHELF_PRICE_CENTS = 19;

/**
 * DE: Richtpreis einer Packung im Markt, ohne Angebote und eigene Korrekturen.
 * Gerundet auf einen typischen Regalpreis mit Endung ,x9.
 * EN: Estimated package price in a store, without offers or own corrections.
 * Rounded to a typical shelf price ending in .x9.
 */
export function defaultPrice(product: Product, store: Store): number {
  if (store.priceFactor === 1) return product.basePrice;
  const raw = product.basePrice * store.priceFactor;
  const shelfCents = Math.round(raw * 10) * 10 - 1;
  return Math.max(MIN_SHELF_PRICE_CENTS, shelfCents) / 100;
}
